import { IonIcon, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";
import "./CareTeamEmergencyAlert.scss";
import { close } from "ionicons/icons";
import EMSCareTeamAlertList from "../EMSCareTeamAlertList/EMSCareTeamAlertList";

interface ContainerProps {
  showPatientAlert: boolean;
  showAlert: () => void;
  patientInputParams: any;
  isFromRejectStatus?: any;
  isFromCareTeamMembersAlert?: any;
}
const CareTeamEmergencyAlert: React.FC<ContainerProps> = (props: any) => {
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [incomingPatientsListData, setIncomingPatientsListData]: any =
    useState();

  useEffect(() => {
    if (props.showPatientAlert) {
      displayPatientAlert();
      setIncomingPatientsListData(props.patientInputParams);
    }
  }, [props.patientInputParams]);

  const displayPatientAlert = () => {
    setShowModalAlert(true);
  };

  const updatedList = (ems_id: any) => {
    if (ems_id) {
      props.patientInputParams.splice(
        props.patientInputParams.findIndex(function (i: any) {
          return i.id === ems_id;
        }),
        1
      );
      setIncomingPatientsListData(props.patientInputParams);
      setModalPopupStatus(props.patientInputParams.length);
    }
  };

  const setModalPopupStatus = (list_length: any) => {
    if (list_length == 0) {
      setShowModalAlert(false);
    }
  };

  const updateAlertHeight = () => {
    if (incomingPatientsListData?.length >= 2) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <IonModal
      isOpen={showModalAlert}
      className={`ems-care-team-alert-modal ${
        updateAlertHeight() ? "adjust-provider-height" : ""
      }`}
      backdropDismiss={false}
    >
      <div className="alert-ems-main-container">
        <div
          className="close-icon-attachment"
          onClick={() => {
            setShowModalAlert(false);
          }}
        >
          <IonIcon icon={close}></IonIcon>
        </div>
        <div className="content-area">
          <h3 className="label">Emergency Case</h3>
          <div className="ems-provider-alert-list-container">
            {incomingPatientsListData &&
              incomingPatientsListData.map((patientData: any) => {
                return (
                  <EMSCareTeamAlertList
                    patientInputParams={patientData}
                    updateList={updatedList}
                    isFromCareTeamMembersAlert={
                      props.isFromCareTeamMembersAlert
                    }
                  ></EMSCareTeamAlertList>
                );
              })}
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default CareTeamEmergencyAlert;
